import { applyMiddleware, combineReducers, createStore } from "redux";
import thunk from "redux-thunk";
import coursesReducer from "./reducers/coursesReducer";
import editReducer from "./reducers/editReducer";
import formStatusReducer from "./reducers/formStatusReducer";
import headerReducer from "./reducers/headerReducer";
import questionFormStatusReducer from "./reducers/questionFormStatusReducer";
import questionReducer from "./reducers/questionReducer";
import quizzesReducer from "./reducers/quizzesReducer";
import sliderReducer from "./reducers/sliderReducer";
import settingsReducer from "./reducers/settingsReducer";
import announcementsReducer from "./reducers/announcementsReducer";
import statisticsReducer from "./reducers/statisticsReducer";
import leadershipBoardReducer from "./reducers/leadershipBoardReducer";
import reportsReducer from "./reducers/reportsReducer";
import selectCourseReducer from "./reducers/selectCourseReducer";
import searchReducer from "./reducers/searchReducer";
import courseViewReducer from "./reducers/courseViewReducer";
import advancedSearchReducer from "./reducers/advancedSearchReducer";
import commentsReducer from "./reducers/commentsReducer";
import courseLeadershipBoardReducer from "./reducers/courseLeadershipBoardReducer";
import scheduleReducer from "./reducers/scheduleReducer";
import calendarMonthReducer from "./reducers/calendarMonthReducer";
import classesReducer from "./reducers/classesReducer";
import categoriesReducer from "./reducers/categoriesReducer";
import categoryItemsReducer from "./reducers/categoryItemsReducer";
import selectedScheduleIdReducer from "./reducers/selectedScheduleIdReducer";
import liveCoursesReducer from "./reducers/liveCoursesReducer";
import accessTokenReducer from "./reducers/accessTokenReducer";
import registerReducer from './reducers/registerReducer';
import ExamscheduleReducer from './reducers/ExamscheduleReducer'
import ExamanswerReducer from './reducers/ExamanswerReducer';
import reportsStudentListReducer from './reducers/reportsStudentListReducer';
import tutorSubjectListReducer from './reducers/tutorSubjectListReducer';
import tutorSubjectExamScheduleReducer from './reducers/tutorSubjectExamScheduleReducer';
import ExamScheduleStudentListReducer from './reducers/ExamScheduleStudentListReducer';


const rootReducer = combineReducers({
    sliderState: sliderReducer,
    coursesState: coursesReducer,
    headerState: headerReducer,
    formStatus: formStatusReducer,
    editState: editReducer,
    settingsState: settingsReducer,
    quizzesState: quizzesReducer,
    questionFormStatus: questionFormStatusReducer,
    questionsState: questionReducer,
    announcementsState: announcementsReducer,
    statisticsState: statisticsReducer,
    leadershipBoardState: leadershipBoardReducer,
    reportsState: reportsReducer,
    selectedCourseState: selectCourseReducer,
    searchState: searchReducer,
    courseViewState: courseViewReducer,
    advancedSearchState: advancedSearchReducer,
    commentsState: commentsReducer,
    courseLeadershipBoardState: courseLeadershipBoardReducer,
    scheduleState: scheduleReducer,
    calendarMonthState: calendarMonthReducer,
    classesState: classesReducer,
    categoriesState: categoriesReducer,
    categoryItemsState: categoryItemsReducer,
    selectedScheduleIdState: selectedScheduleIdReducer,
    liveCoursesState: liveCoursesReducer,
    accessTokenState: accessTokenReducer,
    registerState: registerReducer,
    ExamscheduleState : ExamscheduleReducer,
    ExamAnswerState : ExamanswerReducer,
    ReportStudentListData:reportsStudentListReducer,
    TutorSubjectsList:tutorSubjectListReducer,
    TutorSubjectExamSchedules:tutorSubjectExamScheduleReducer,
    ExamScheduleStudentList:ExamScheduleStudentListReducer

});

export const store = createStore(rootReducer, applyMiddleware(thunk))